import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import editTopThreatsByProcessDialog from './dialog.editTopThreatsByProcessDialog';
import topThreats from './topThreats';
import directive from './top-threats-by-process.directive';
import controller from './top-threats-by-process.controller';


export default angular.module('app.components.advisory.bcp.topThreatsByProcess', [
  constants,
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
  topThreats,
  editTopThreatsByProcessDialog,
])
  .directive('bcpTopThreatsByProcess', directive)
  .controller('TopThreatsByProcessController', controller)
  .name;

console.log('app.components.advisory.bcp.topThreatsByProcess created');
